import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {
    overflow: 'hidden',
    height: 40,
    width: 40,
    borderRadius: 99999,
  },
  rotation: {
    height: 40,
    width: 40,
    borderRadius: 99999,
  },
  image: {
    position: 'absolute',
    height: 160,
    width: 240,
    top: 0,
    left: 0,
  },
});
